import { Pressable, StyleSheet, View } from 'react-native';
import { router } from 'expo-router';

import DefaultBackground from '@/components/DefaultBackground';
import { EventHandlingDemo } from '@/components/EventHandlingDemo';
import TopbarLogo from '@/components/TopbarLogo';
import { ThemedText } from '@/components/ThemedText';
import { ThemedView } from '@/components/ThemedView';
import { useScale } from '@/hooks/useScale';

export default function TVNativeEventsDebugScreen() {
  const styles = useStyles();

  return (
    <ThemedView style={styles.container}>
      <DefaultBackground />

      {/* Top bar */}
      <View style={styles.topBar}>
        <Pressable
          style={({ focused }) => [
            styles.backButton,
            focused && styles.backButtonFocused,
          ]}
          onPress={() => router.back()}
        >
          <ThemedText style={styles.backButtonText}>Back</ThemedText>
        </Pressable>
        <View style={styles.topBarSpacer} />
        <TopbarLogo />
        <View style={styles.topBarSpacer} />
        <View style={styles.backButtonPlaceholder} />
      </View>

      <ThemedText style={styles.title}>TV Native Events</ThemedText>
      <ThemedText style={styles.subtitle}>
        Press buttons on the remote (play/pause, arrows, select, swipes) and
        watch the log update.
      </ThemedText>

      <View style={styles.body}>
        <EventHandlingDemo />
      </View>
    </ThemedView>
  );
}

const useStyles = function () {
  const scale = useScale();
  return StyleSheet.create({
    container: {
      flex: 1,
    },
    topBar: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 24 * scale,
      paddingHorizontal: 24 * scale,
    },
    topBarSpacer: {
      flex: 1,
    },
    backButton: {
      paddingVertical: 8 * scale,
      paddingHorizontal: 20 * scale,
      backgroundColor: 'rgba(255,255,255,0.15)',
      borderRadius: 20 * scale,
      borderWidth: 2,
      borderColor: 'transparent',
    },
    backButtonFocused: {
      backgroundColor: 'rgba(255,255,255,0.3)',
      borderColor: '#fff',
    },
    backButtonPlaceholder: {
      width: 80 * scale,
    },
    backButtonText: {
      color: '#fff',
      fontSize: 14 * scale,
      fontWeight: '600',
    },
    title: {
      color: '#fff',
      fontSize: 28 * scale,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 8 * scale,
    },
    subtitle: {
      color: 'rgba(255,255,255,0.7)',
      fontSize: 14 * scale,
      textAlign: 'center',
      marginBottom: 16 * scale,
      paddingHorizontal: 40 * scale,
    },
    body: {
      flex: 1,
    },
  });
};
